<div data-cy="auth-office-auto-login" style="text-align: center; margin-top: 100px;margin-left: auto;margin-right: auto;" >{{outStr}}</div>

